import {
    createField,
    updateField,
} from '../../actions';
import {
    EVENT_STEP_VALIDATE,
    COUNTRY_NETHERLANDS,
} from '../../helpers/consts';

export class CountrySelectField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Select a country'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        const productLanguage = this.state.product.language ? this.state.product.language.split('-')[1] : COUNTRY_NETHERLANDS;
        this.value = (fieldState && fieldState.value) ? fieldState.value : productLanguage;
        this.isValid = true;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement() { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$customSelect = document.createElement('div');
        this.$fieldSelect = document.createElement('select');
        this.$fieldMessage = document.createElement('span');

        this.$fieldSelect.innerHTML = `
        <option value="AF">Afghanistan</option>
        <option value="AX">Åland</option>
        <option value="AL">Albanië</option>
        <option value="DZ">Algerije</option>
        <option value="VI">Amerikaanse Maagdeneilanden</option>
        <option value="AS">Amerikaans-Samoa</option>
        <option value="AD">Andorra</option>
        <option value="AO">Angola</option>
        <option value="AI">Anguilla</option>
        <option value="AQ">Antarctica</option>
        <option value="AG">Antigua en Barbuda</option>
        <option value="EH">Arabische Democratische Republiek Sahara</option>
        <option value="AR">Argentinië</option>
        <option value="AM">Armenië</option>
        <option value="AW">Aruba</option>
        <option value="AU">Australië</option>
        <option value="AZ">Azerbeidzjan</option>
        <option value="BS">Bahama's</option>
        <option value="BH">Bahrein</option>
        <option value="BD">Bangladesh</option>
        <option value="BB">Barbados</option>
        <option value="BE">België</option>
        <option value="BZ">Belize</option>
        <option value="BJ">Benin</option>
        <option value="BM">Bermuda</option>
        <option value="BT">Bhutan</option>
        <option value="BO">Bolivia</option>
        <option value="BQ">Bonaire, Sint Eustatius en Saba</option>
        <option value="BA">Bosnië en Herzegovina</option>
        <option value="BW">Botswana</option>
        <option value="BV">Bouvet</option>
        <option value="BR">Brazilië</option>
        <option value="IO">Brits Indische Oceaanterritorium</option>
        <option value="VG">Britse Maagdeneilanden</option>
        <option value="BN">Brunei</option>
        <option value="BG">Bulgarije</option>
        <option value="BF">Burkina Faso</option>
        <option value="BI">Burundi</option>
        <option value="KH">Cambodja</option>
        <option value="CA">Canada</option>
        <option value="CF">Centraal-Afrikaanse Republiek</option>
        <option value="CL">Chili</option>
        <option value="CN">China</option>
        <option value="CX">Christmaseiland</option>
        <option value="CC">Cocoseilanden</option>
        <option value="CO">Colombia</option>
        <option value="KM">Comoren</option>
        <option value="CK">Cookeilanden</option>
        <option value="CR">Costa Rica</option>
        <option value="CU">Cuba</option>
        <option value="CW">Curaçao</option>
        <option value="CY">Cyprus</option>
        <option value="CD">Democratische Republiek Congo</option>
        <option value="DK">Denemarken</option>
        <option value="DJ">Djibouti</option>
        <option value="DM">Dominica</option>
        <option value="DO">Dominicaanse Republiek</option>
        <option value="DE">Duitsland</option>
        <option value="EC">Ecuador</option>
        <option value="EG">Egypte</option>
        <option value="SV">El Salvador</option>
        <option value="GQ">Equatoriaal-Guinea</option>
        <option value="ER">Eritrea</option>
        <option value="EE">Estland</option>
        <option value="ET">Ethiopië</option>
        <option value="FO">Faeröer</option>
        <option value="FK">Falklandeilanden</option>
        <option value="FJ">Fiji</option>
        <option value="PH">Filipijnen</option>
        <option value="FI">Finland</option>
        <option value="FR">Frankrijk</option>
        <option value="TF">Franse Zuidelijke en Antarctische Gebieden</option>
        <option value="GF">Frans-Guyana</option>
        <option value="PF">Frans-Polynesië</option>
        <option value="GA">Gabon</option>
        <option value="GM">Gambia</option>
        <option value="GE">Georgië</option>
        <option value="GH">Ghana</option>
        <option value="GI">Gibraltar</option>
        <option value="GD">Grenada</option>
        <option value="GR">Griekenland</option>
        <option value="GL">Groenland</option>
        <option value="GP">Guadeloupe</option>
        <option value="GU">Guam</option>
        <option value="GT">Guatemala</option>
        <option value="GG">Guernsey</option>
        <option value="GN">Guinee</option>
        <option value="GW">Guinee-Bissau</option>
        <option value="GY">Guyana</option>
        <option value="HT">Haïti</option>
        <option value="HM">Heard en McDonaldeilanden</option>
        <option value="HN">Honduras</option>
        <option value="HU">Hongarije</option>
        <option value="HK">Hongkong</option>
        <option value="IE">Ierland</option>
        <option value="IS">IJsland</option>
        <option value="IN">India</option>
        <option value="ID">Indonesië</option>
        <option value="IQ">Irak</option>
        <option value="IR">Iran</option>
        <option value="IM">Isle of Man</option>
        <option value="IL">Israël</option>
        <option value="IT">Italië</option>
        <option value="CI">Ivoorkust</option>
        <option value="JM">Jamaica</option>
        <option value="JP">Japan</option>
        <option value="YE">Jemen</option>
        <option value="JE">Jersey</option>
        <option value="JO">Jordanië</option>
        <option value="KY">Kaaimaneilanden</option>
        <option value="CV">Kaapverdië</option>
        <option value="CM">Kameroen</option>
        <option value="KZ">Kazachstan</option>
        <option value="KE">Kenia</option>
        <option value="KG">Kirgizië</option>
        <option value="KI">Kiribati</option>
        <option value="UM">Kleine Pacifische eilanden van de Verenigde Staten</option>
        <option value="KW">Koeweit</option>
        <option value="XK">Kosovo</option>
        <option value="HR">Kroatië</option>
        <option value="LA">Laos</option>
        <option value="LS">Lesotho</option>
        <option value="LV">Letland</option>
        <option value="LB">Libanon</option>
        <option value="LR">Liberia</option>
        <option value="LY">Libië</option>
        <option value="LI">Liechtenstein</option>
        <option value="LT">Litouwen</option>
        <option value="LU">Luxemburg</option>
        <option value="MO">Macau</option>
        <option value="MK">Macedonië</option>
        <option value="MG">Madagaskar</option>
        <option value="MW">Malawi</option>
        <option value="MV">Maldiven</option>
        <option value="MY">Maleisië</option>
        <option value="ML">Mali</option>
        <option value="MT">Malta</option>
        <option value="MA">Marokko</option>
        <option value="MH">Marshalleilanden</option>
        <option value="MQ">Martinique</option>
        <option value="MR">Mauritanië</option>
        <option value="MU">Mauritius</option>
        <option value="YT">Mayotte</option>
        <option value="MX">Mexico</option>
        <option value="FM">Micronesia</option>
        <option value="MD">Moldavië</option>
        <option value="MC">Monaco</option>
        <option value="MN">Mongolië</option>
        <option value="ME">Montenegro</option>
        <option value="MS">Montserrat</option>
        <option value="MZ">Mozambique</option>
        <option value="MM">Myanmar</option>
        <option value="NA">Namibië</option>
        <option value="NR">Nauru</option>
        <option value="NL">Nederland</option>
        <option value="AN">Nederlandse Antillen</option>
        <option value="NP">Nepal</option>
        <option value="NI">Nicaragua</option>
        <option value="NC">Nieuw-Caledonië</option>
        <option value="NZ">Nieuw-Zeeland</option>
        <option value="NE">Niger</option>
        <option value="NG">Nigeria</option>
        <option value="NU">Niue</option>
        <option value="MP">Noordelijke Marianen</option>
        <option value="KP">Noord-Korea</option>
        <option value="NO">Noorwegen</option>
        <option value="NF">Norfolk</option>
        <option value="UG">Oeganda</option>
        <option value="UA">Oekraïne</option>
        <option value="UZ">Oezbekistan</option>
        <option value="OM">Oman</option>
        <option value="AT">Oostenrijk</option>
        <option value="TL">Oost-Timor</option>
        <option value="PK">Pakistan</option>
        <option value="PW">Palau</option>
        <option value="PS">Palestijnse Gebieden</option>
        <option value="PA">Panama</option>
        <option value="PG">Papoea-Nieuw-Guinea</option>
        <option value="PY">Paraguay</option>
        <option value="PE">Peru</option>
        <option value="PN">Pitcairneilanden</option>
        <option value="PL">Polen</option>
        <option value="PT">Portugal</option>
        <option value="PR">Puerto Rico</option>
        <option value="QA">Qatar</option>
        <option value="CG">Republiek Congo</option>
        <option value="RE">Réunion</option>
        <option value="RO">Roemenië</option>
        <option value="RU">Rusland</option>
        <option value="RW">Rwanda</option>
        <option value="KN">Saint Kitts en Nevis</option>
        <option value="LC">Saint Lucia</option>
        <option value="VC">Saint Vincent en de Grenadines</option>
        <option value="BL">Saint-Barthélemy</option>
        <option value="PM">Saint-Pierre en Miquelon</option>
        <option value="SB">Salomonseilanden</option>
        <option value="WS">Samoa</option>
        <option value="SM">San Marino</option>
        <option value="ST">Sao Tomé en Principe</option>
        <option value="SA">Saoedi-Arabië</option>
        <option value="SN">Senegal</option>
        <option value="RS">Servië</option>
        <option value="SC">Seychellen</option>
        <option value="SL">Sierra Leone</option>
        <option value="SG">Singapore</option>
        <option value="SX">Sint Maarten</option>
        <option value="MF">Sint Maarten (2)</option>
        <option value="SH">Sint-Helena, Ascension en Tristan da Cunha</option>
        <option value="SI">Slovenië</option>
        <option value="SK">Slowakije</option>
        <option value="SD">Soedan</option>
        <option value="SO">Somalië</option>
        <option value="ES">Spanje</option>
        <option value="SJ">Spitsbergen</option>
        <option value="LK">Sri Lanka</option>
        <option value="SR">Suriname</option>
        <option value="SZ">Swaziland</option>
        <option value="SY">Syrië</option>
        <option value="TJ">Tadzjikistan</option>
        <option value="TW">Taiwan</option>
        <option value="TZ">Tanzania</option>
        <option value="TH">Thailand</option>
        <option value="TG">Togo</option>
        <option value="TK">Tokelau-eilanden</option>
        <option value="TO">Tonga</option>
        <option value="TT">Trinidad en Tobago</option>
        <option value="TD">Tsjaad</option>
        <option value="CZ">Tsjechië</option>
        <option value="TN">Tunesië</option>
        <option value="TR">Turkije</option>
        <option value="TM">Turkmenistan</option>
        <option value="TC">Turks- en Caicoseilanden</option>
        <option value="TV">Tuvalu</option>
        <option value="UY">Uruguay</option>
        <option value="VU">Vanuatu</option>
        <option value="VA">Vaticaanstad</option>
        <option value="VE">Venezuela</option>
        <option value="GB">Verenigd Koninkrijk</option>
        <option value="AE">Verenigde Arabische Emiraten</option>
        <option value="US">Verenigde Staten van Amerika</option>
        <option value="VN">Vietnam</option>
        <option value="WF">Wallis en Futuna</option>
        <option value="BY">Wit-Rusland</option>
        <option value="ZM">Zambia</option>
        <option value="ZW">Zimbabwe</option>
        <option value="ZA">Zuid-Afrika</option>
        <option value="GS">Zuid-Georgia en de Zuidelijke Sandwicheilanden</option>
        <option value="KR">Zuid-Korea</option>
        <option value="SS">Zuid-Soedan</option>
        <option value="SE">Zweden</option>
        <option value="CH">Zwitserland</option>
        `
        this.$fieldSelect.id = this.id;
        this.$fieldSelect.required = this.required;
        this.$fieldSelect.value = this.value ? this.value : 'NL';
        this.$fieldSelect.autocomplete = 'no';
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--country')
        $fieldLabel.classList.add('control-label');
        this.$customSelect.classList.add('formControls');
        this.$fieldSelect.classList.add('field-select--country', 'custom-select', 'form-control');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');
        this.$customSelect.append(this.$fieldSelect);
        
        $field.appendChild($fieldLabel);
        $field.appendChild(this.$customSelect);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldSelect.addEventListener('blur', this.validate.bind(this));
        this.$fieldSelect.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    getSelectElement() {
        return this.$fieldSelect;
    }

    validate() {
        this.$fieldSelect.classList.remove('is-invalid');
        this.$fieldSelect.classList.remove('is-valid');
        this.isValid = (this.$fieldSelect.value !== '');

        if (this.isValid) {
            // Valid credit card number
            this.$fieldSelect.classList.remove('is-invalid');
            this.$fieldSelect.classList.add('is-valid');
            this.isValid = true;
        } else {
            this.$fieldSelect.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty;
            this.isValid = false;
        }

        this.store.dispatch(updateField(this.id, this.$fieldSelect.value, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default CountrySelectField;
